import React, { useEffect, useState } from "react";
import { Box, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BuyButton from "./BuyButton";

const PromotionPopup = ({ open, onClose, product, code, image, heroImage, productName, campaign, discount }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const [heroFailed, setHeroFailed] = useState(false);
  useEffect(() => { setImageFailed(false); }, [image]);
  useEffect(() => { setHeroFailed(false); }, [heroImage]);
  const hasTourImage = Boolean(image) && !imageFailed;
  const displayImage = hasTourImage ? image : !heroFailed ? heroImage : undefined;

  return <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs"
    aria-labelledby="promotion-title"
    sx={{ zIndex: (theme) => theme.zIndex.tooltip + 1 }}
    PaperProps={{
      elevation: 10,
      sx: {
        borderRadius: 3,
        border: "1px solid rgba(255,255,255,0.16)",
        color: "#fff",
        background: "radial-gradient(ellipse at top, #343434, #151515 75%)",
      },
    }}
  >
    <IconButton aria-label="Close promotion" onClick={onClose}
      sx={{ position: "absolute", right: 8, top: 8, zIndex: 1, color: "#fff", bgcolor: "rgba(0,0,0,0.55)", "&:hover": { bgcolor: "rgba(0,0,0,0.8)" } }}
    ><CloseIcon /></IconButton>
    {displayImage && <Box sx={{ px: hasTourImage ? 0 : 3, pt: hasTourImage ? 0 : 6 }}>
      <Box component="img" src={displayImage} alt={hasTourImage ? campaign || "Tour promotion" : `${productName} plugin`}
        onError={() => hasTourImage ? setImageFailed(true) : setHeroFailed(true)}
        sx={{ display: "block", width: "100%", maxHeight: hasTourImage ? 320 : 220, objectFit: "contain" }} />
    </Box>}
    <DialogContent sx={{ textAlign: "center", px: { xs: 3, sm: 5 }, pt: displayImage ? 3 : 7, pb: 4 }}>
      <Typography component="p" sx={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "#bbb", mb: 2 }}>
        {campaign || "A little extra for your tone"}
      </Typography>
      <Typography id="promotion-title" component="h2"
        sx={{ fontSize: { xs: 26, sm: 30 }, fontWeight: 700, lineHeight: 1.2, mb: 2 }}>
        {discount || "Your special offer"}
      </Typography>
      <Typography sx={{ fontSize: 14, color: "#ccc", lineHeight: 1.6 }}>
        {discount ? "Claim your discount at checkout." : "Enter your promotion code at checkout to check availability."}
      </Typography>
      <Box sx={{ display: "inline-block", mt: 3, px: 2, py: 1.25, border: "1px dashed #777", borderRadius: 1, maxWidth: "100%", boxSizing: "border-box" }}>
        <Typography sx={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.12em", color: "#aaa", mb: 0.5 }}>Promotion code</Typography>
        <Typography sx={{ fontFamily: "monospace", fontSize: 15, fontWeight: 700, letterSpacing: "0.06em", overflowWrap: "anywhere" }}>{code}</Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <BuyButton text="Claim Offer" product={product} sx={{ width: "100%", borderRadius: 2, py: 1.5 }} />
      </Box>
    </DialogContent>
  </Dialog>;
};

export default PromotionPopup;
